export default "__VITE_ASSET__DgzkGwFv__"